<template>
  <div class="system-config-management">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div class="filter-card">
        <div class="filter-bar">
          <div class="action-group">
            <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加配置</el-button>
          </div>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>
      <el-empty
        v-else-if="!loading && configs.length === 0"
        description="暂无数据"
      />

      <div v-else>
        <!-- Search and Filter -->
        <el-table
          :data="configs"
          border
          stripe
          v-loading="loading"
          element-loading-text="正在加载..."
          class="animate__animated animate__fadeIn"
          row-key="id"
        >
          <el-table-column prop="id" label="ID" width="80" align="center" />
          <el-table-column prop="configKey" label="配置键" min-width="160" show-overflow-tooltip />
          <el-table-column prop="configValue" label="配置值" min-width="200" show-overflow-tooltip />
          <el-table-column prop="description" label="描述" min-width="200" show-overflow-tooltip />
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                icon="el-icon-edit"
                @click="handleEdit(scope.row)"
              >编辑</el-button>
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                style="margin-left: 10px;"
                @click="handleDelete(scope.row.id)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.page"
            :page-size="pagination.pageSize"
            :page-sizes="[5, 10, 20, 50]"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </el-card>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      center
      append-to-body
    >
      <el-form :model="form" label-width="90px">
        <el-form-item label="配置键">
          <el-input v-model.trim="form.configKey" :disabled="isEdit" autocomplete="off" placeholder="请输入配置键" />
        </el-form-item>
        <el-form-item label="配置值">
          <el-input v-model.trim="form.configValue" autocomplete="off" placeholder="请输入配置值" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            type="textarea"
            :rows="3"
            v-model.trim="form.description"
            autocomplete="off"
            placeholder="请输入描述"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get, post, put, del, getResponseMessage } from '@/utils/http.js'

export default {
  name: 'SystemConfigManagement',
  data() {
    return {
      loading: false,
      error: '',
      configs: [],

      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      isEdit: false,
      form: {
        id: null,
        configKey: '',
        configValue: '',
        description: ''
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑配置' : '新增配置'
    }
  },
  mounted() {
    this.fetchConfigs()
  },
  methods: {
    async fetchConfigs() {
      this.error = ''
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }

        const result = await get('/admin/config/page', params)
        const data = result.data || {}
        this.configs = Array.isArray(data.records) ? data.records : []
        this.pagination.total = data.total || 0
        this.pagination.pageSize = data.pageSize || this.pagination.pageSize
        this.pagination.page = data.page || this.pagination.page
      } catch (e) {
        this.error = e && e.message ? e.message : '请求出现错误'
        this.configs = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },

    handleCurrentChange(page) {
      this.pagination.page = page
      this.fetchConfigs()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchConfigs()
    },
    handleAdd() {
      this.isEdit = false
      this.form = {
        id: null,
        configKey: '',
        configValue: '',
        description: ''
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.form = {
        id: row.id,
        configKey: row.configKey,
        configValue: row.configValue,
        description: row.description
      }
      this.dialogVisible = true
    },
    async handleSubmit() {
      if (!this.form.configKey) {
        this.$message.error('配置键不能为空')
        return
      }
      if (!this.form.configValue) {
        this.$message.error('配置值不能为空')
        return
      }
      try {
        if (this.isEdit) {
          const payload = {
            configKey: this.form.configKey,
            configValue: this.form.configValue,
            description: this.form.description
          }
          const result = await put(`/admin/config/${this.form.id}`, payload)
          this.dialogVisible = false
          this.$message.success(getResponseMessage(result, '编辑成功'))
        } else {
          const payload = {
            configKey: this.form.configKey,
            configValue: this.form.configValue,
            description: this.form.description
          }
          const result = await post('/admin/config', payload)
          this.dialogVisible = false
          this.$message.success(getResponseMessage(result, '添加成功'))
        }
        this.fetchConfigs()
      } catch (e) {
        this.$message.error(e && e.message ? e.message : '操作失败')
      }
    },
    async handleDelete(id) {
      try {
        await this.$confirm('确定要删除该配置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const result = await del(`/admin/config/${id}`)
        this.$message.success(getResponseMessage(result, '删除成功'))
        if (this.configs.length === 1 && this.pagination.page > 1) {
          this.pagination.page -= 1
        }
        this.fetchConfigs()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e && e.message ? e.message : '删除失败')
        }
      }
    }
  }
}
</script>

<style scoped>
.system-config-management {
}

.error {
  color: #f87171;
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  padding: 8px 10px;
  border-radius: 6px;
  margin-bottom: 12px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.filter-card {
  margin-bottom: 20px;
}

/* Speed up animations */
.el-card.animate__animated,
.el-table.animate__animated {
  --animate-duration: 0.3s;
}

/* 移除动画，立即显示 */
.el-dialog.animate__zoomIn {
  --animate-duration: 0s;
}
</style>